// A qué ítem del menú pertenece la pantalla actual (Martin, 28 sep 2026:
// permisos por PERSONA para todos los módulos). api/client.js lo manda en cada
// pedido (header X-Menu-Item) y el backend (AccesoPorPersona) rechaza lo que
// sale de un ítem restringido si la persona no está en su lista.
//
// El catálogo lo registra Layout.jsx (SECTIONS) al cargar; acá no se importa
// Layout para no crear un ciclo client.js → Layout → client.js.

let paths = []

// Pantallas de la versión móvil (/m) → su ítem de escritorio. El orden importa:
// la regla más específica primero.
const MOVIL = [
  [/^\/m\/clientes\/[^/]+\/historia/, '/clientes/historia'],
  [/^\/m\/historia/, '/clientes/historia'],
  [/^\/m\/ventas/, '/notas-venta'],
  [/^\/m\/clientes/, '/clientes'],
  [/^\/m\/deudores/, '/clientes/deudores'],
  [/^\/m\/logistica/, '/logistica/remitos'],
  [/^\/m\/reparto/, '/logistica/distribucion'],
  [/^\/m\/pagos/, '/finanzas/pagos'],
  [/^\/m\/resenas/, '/clientes/resenas'],
  [/^\/m\/wine-club/, '/clientes/wine-club'],
  [/^\/m\/experiencias/, '/web/experiencias'],
  [/^\/m\/whatsapp/, '/comunicaciones/whatsapp'],
  [/^\/m\/precios-ml/, '/sistema/mercadolibre'],
  [/^\/m\/fotos/, '/stock/fotos-pendientes'],
  [/^\/m\/conteo/, '/stock/inventario'],
  [/^\/m\/consultas-stock/, '/stock/consultas-deposito'],
  [/^\/m\/reportes/, '/bi/reportes'],
]

/** Layout registra todos los paths del menú (secciones, subsecciones y EMP 900). */
export function registrarItemsDelMenu(lista) {
  // El más largo primero: /comunicaciones/whatsapp/equipos gana sobre /comunicaciones/whatsapp.
  paths = [...new Set(lista.filter(Boolean))].sort((a, b) => b.length - a.length)
}

/** El ítem del menú de una ruta (el path más largo que la contiene), o null. */
export function menuItemDe(pathname) {
  if (!pathname) return null
  for (const [re, item] of MOVIL) if (re.test(pathname)) return item
  return paths.find(p => pathname === p || pathname.startsWith(p + '/')) || null
}

export function menuItemActual() {
  return typeof window === 'undefined' ? null : menuItemDe(window.location.pathname)
}
